import React from "react";

export default function MatkaMarketCard({ market, onClick }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
      <div className="matka-market-card" onClick={onClick}>
        <div className="matka-card-top-content">
          <p className="matka-card-status">{market.status}</p>
          <h3 className="matka-card-digits">{market.numbers}</h3>
          <div className="matka-card-times d-flex justify-content-between align-items-center">
            <span className="matka-time-label">
              Open <strong>{market.openTime}</strong>
            </span>
            <span className="matka-time-label">
              Close <strong>{market.closeTime}</strong>
            </span>
          </div>
        </div>
        <div className="matka-card-bottom-banner">
          <span className="matka-market-title">{market.name}</span>
        </div>
      </div>
    </div>
  );
}
